import { render, staticRenderFns } from "./PremiumShared.vue?vue&type=template&id=0fb469ec&"
import script from "./PremiumShared.vue?vue&type=script&lang=js&"
export * from "./PremiumShared.vue?vue&type=script&lang=js&"
import style0 from "./PremiumShared.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PremiumShared.vue"
export default component.exports